const configs = {
  foundation: {
    name: '人事組織模組',
    steps: {
      jobTitle: {
        name: '職稱設定',
        step: 1,
      },
      employee: {
        name: '人員資料',
        step: 2,
      },
      org: {
        name: '組織資料',
        step: 3,
      },
    },
  },
  attendance: {
    name: '行動出勤',
    steps: {
      qa: {
        name: '上下班/彈性工時',
        step: 4,
      },
      remainLeave: {
        name: '剩餘假別',
        step: 5,
      },
      checkIn: {
        name: '打卡方式',
        step: 6,
      },
      shiftSchedule: {
        name: '排班設定',
        step: 7,
      },
    },
  },
  payroll: {
    name: '智慧結薪',
    steps: {
      qa: {
        name: '發薪',
        step: 8,
      },
      company: {
        name: '公司發薪',
        step: 9,
      },
      employee: {
        name: '員工發薪',
        step: 10,
      },
    },
  },
  active: {
    name: 'Apollo XE',
    steps: {
      admin: {
        name: '總管理者設定',
        step: 11,
      },
      active: {
        name: '啟用 Apollo XE',
        step: 12,
      },
    },
  },
};

export default configs;
